module.exports = __webpack_public_path__ + "img/customer.3624b0c4.svg";